import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';

let openConfirmDialogFn;

const styles = (theme) => ({
  paper: {
    // display: 'flex',
    // alignItems: 'center',
  },
});

class ConfirmationDialog extends React.Component {
  state = {
    open: false,
    title: 'Confirm',
    message: 'Are you sure?',
  };

  componentDidMount() {
    openConfirmDialogFn = this.openConfirmDialog;
  }

  openConfirmDialog = (options) => {
    return new Promise((resolve, reject) => {
      this.setState({
        open: true,
        resolve,
        reject,
        ...options,
      });
    });
  };

  handleCancel = () => {
    this.setState({ open: false });
    this.state.resolve('Cancel');
  };

  handleOk = () => {
    this.setState({ open: false });
    this.state.resolve('OK');
  };

  render() {
    const { value, ...other } = this.props;
    const { open, title, message } = this.state;

    return (
      <Dialog aria-labelledby="confirmation-dialog-title" open={open} {...other}>
        <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} variant="contained" color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export function openConfirmDialog(options) {
  return openConfirmDialogFn(options);
}

export default withStyles(styles)(ConfirmationDialog);
